import { CommonRequestResponseService } from './common-request-response.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClassBaseService {

  constructor(private _commonRequestResponseService: CommonRequestResponseService) { }

  // JDO - 1.9.2018: Be sure to keep all methods in alphabetical order for easier scanning
  // JDO - 1.22.2018: Add nullable partnerId to input param as needed and parse via getPartnerInput()

  getApplicationStatusList(): Observable<any[]> {
    return this.getClassType('Application Status');
  }
  getBrickTemperatureList(partnerId?): Observable<any[]> {
    const partnerIdInput = this.getPartnerInput(partnerId);
    return this.getClassType('Brick Temperature', partnerIdInput);
  }

  getCareerList(): Observable<any[]> {
    return this.getClassType('Careers');
  }

  // getCareerCluster(): Observable<any[]> {
  //   return this.getClassType('Career Cluster');
  // }

  getCitySizeList(): Observable<any[]> {
    return this.getClassType('City Size');
  }

  getClassRankList(): Observable<any[]> {
    return this.getClassType('Class Rank');
  }

  // getClassSizeList(): Observable<any[]> {
  //   return this.getClassType('Class Size');
  // }
  //
  // getClubSportsList(): Observable<any[]> {
  //   return this.getClassType('Club Sports');
  // }
  //
  // getCollegeTypes(): Observable<any[]> {
  //   return this.getClassType('College Type');
  // }

  getContentTypes(): Observable<any[]> {
    return this.getClassType('Content Type');
  }

  // getDegreeList(): Observable<any[]> {
  //   return this.getClassType('Degree');
  // }
  //
  // getDifficultyTypes(): Observable<any[]> {
  //   return this.getClassType('Difficulty');
  // }

  getDocumentTypeList(): Observable<any[]> {
    return this.getClassType('Document Type');
  }

  // getEnthicityList(): Observable<any[]> {
  //   return this.getClassType('Ethnicity');
  // }
  //
  // getGenderList(): Observable<any[]> {
  //   return this.getClassType('Gender');
  // }
  //
  // getGradMonthList(): Observable<any[]> {
  //   return this.getClassType('Graduation Month');
  // }

  getHighSchoolList(): Observable<any[]> {
    return this.getClassType('High School');
  }

  // getHousingOptionList(): Observable<any[]> {
  //   return this.getClassType('Housing Options');
  // }

  getLicenseTypes(): Observable<any[]> {
    return this.getClassType('Licenses');
  }

  // getLocationList(): Observable<any[]> {
  //   return this.getClassType('Location');
  // }

  getMajorList(): Observable<any[]> {
    return this.getClassType('Major');
  }

  getMessageTopicList(): Observable<any[]> {
    return this.getClassType('Message Topics');
  }

  getModuleTypes(): Observable<any[]> {
    return this.getClassType('Modules');
  }

  getParentPageData(): Observable<any[]> {
    return this.getClassType('Parent Menu');
  }

  getPhoneNumberTypes(): Observable<any[]> {
    return this.getClassType('Phone Numbers');
  }

  getProductTypes(): Observable<any[]> {
    return this.getClassType('Products');
  }

  // getReligiousList(): Observable<any[]> {
  //   return this.getClassType('Religious');
  // }

  getRoleTypes(arg?): Observable<any[]> {
    return this.getClassType('Role', arg);
  }

  // getROTCList(): Observable<any[]> {
  //   return this.getClassType('ROTC');
  // }

  getQuarterList(): Observable<any[]> {
    return this.getClassType('School Quarter');
  }

  // getSchoolTypeList(): Observable<any[]> {
  //   return this.getClassType('School Type');
  // }

  getServiceTypes(): Observable<any[]> {
    return this.getClassType('Service Type');
  }

  getSpecialConsiderations(): Observable<any[]> {
    return this.getClassType('Special Considerations');
  }

  getSportsList(): Observable<any[]> {
    return this.getClassType('Sports');
  }

  // getStandardizedTestingPolicies(): Observable<any[]> {
  //   // TODO: Need to address mispelling in API
  //   return this.getClassType('Strandardized Testing policy');
  // }

  getStateList(): Observable<any[]> {
    return this.getClassType('State');
  }

  getStudentGrade(): Observable<any[]> {
    return this.getClassType('Student Grade');
  }

  getStudentHousingOptionList(): Observable<any[]> {
    return this.getClassType('Housing Options');
  }

  getStudentPageData(): Observable<any[]> {
    return this.getClassTypeById();
  }

  getStudentProgessCategories(partnerId?): Observable<any[]> {
    const partnerIdInput = this.getPartnerInput(partnerId);
    return this.getClassType('Student Progress Categories', partnerIdInput);
  }

  getSubjectList(): Observable<any[]> {
    return this.getClassType('Subject');
  }

  getSupportServiceList(partnerId?): Observable<any[]> {
    const partnerIdInput = this.getPartnerInput(partnerId);
    return this.getClassType('support services', partnerIdInput);
  }

  getTimeOfDayIndicatorList(): Observable<any[]> {
    return this.getClassType('Time');
  }

  getTimePeriodFrequency(): Observable<any[]> {
    return this.getClassType('Bulk Email Frequency');
  }

  getViewTypes(): Observable<any[]> {
    return this.getClassType('Student Menu');
  }

  getYearsElectiveList(): Observable<any[]> {
    return this.getClassType('Number of Years Elective');
  }

  getHeatmapProgramData(): Observable<any[]> {
    return this.getClassType('Heatmap Type');
  }

  private getClassType(name, args?): Observable<any[]> {
    const inputJson = args || {};
    const defParam = Object.keys(inputJson);
    inputJson['classTypeName'] = `${name}`;
    return this._commonRequestResponseService.postWithHeader('admin/values/', inputJson, defParam).map((data: any) => data.items);
  }

  private getClassTypeById(): Observable<any[]> {
    const inputJson = ['Student Menu', 'Parent Menu'];
    return this._commonRequestResponseService.postWithHeader('admin/valuesbylist', { classTypeNames: inputJson }).map((data: any) => data.item);
  }

  private getPartnerInput(partnerId?) {
    return partnerId ? { partnerId: partnerId } : null;
  }

}
